import ncFetchDataFromDb from './ncFetchDataFromDb'
import cachedFetchDataFromDb from './cachedFetchDataFromDb'

const getCachedDataBySlug = async (lang, collection, slug) => {
  const fetchObject = {
    collection: collection,
    where: {
      slug: { equals: slug },
    },
    locale: lang?.slice(0, 2),
    depth: 10, // Ensure we get all related documents with sufficient depth
    limit: 1,
  }

  let dataDocs
  if (process.env.STAGING === 'true') {
    dataDocs = await ncFetchDataFromDb(fetchObject, true)
  } else {
    dataDocs = await cachedFetchDataFromDb(fetchObject, true)
  }

  if (dataDocs && dataDocs?.totalDocs && dataDocs.totalDocs > 0) {
    const doc = dataDocs.docs[0]

    // If we have a staticGooglePhoto as a string ID, try to populate it
    if (doc?.staticGooglePhoto && typeof doc.staticGooglePhoto === 'string') {
      try {
        // Fetch the media document
        const mediaFetchObject = {
          collection: 'media',
          where: {
            id: { equals: doc.staticGooglePhoto },
          },
          depth: 0,
          limit: 1,
        }

        let mediaDoc
        if (process.env.STAGING === 'true') {
          mediaDoc = await ncFetchDataFromDb(mediaFetchObject, true)
        } else {
          mediaDoc = await cachedFetchDataFromDb(mediaFetchObject, true)
        }

        if (mediaDoc && mediaDoc?.totalDocs && mediaDoc.totalDocs > 0) {
          doc.staticGooglePhoto = mediaDoc.docs[0]
        }
      } catch (error) {
        console.error('Error populating staticGooglePhoto:', error)
      }
    }

    return doc
  }
  return null
}

export default getCachedDataBySlug
